import React, {useEffect, useState} from "react";
import BodegaModalAgregar from "./bodegaModalAgregar";
import "../static/css/listaBodegas.css";
import {buscarBodegasService, editarBodegasService, guardarBodegasService} from "../service/bodegas/bodegasService";
import {
    mensajeError,
    mensajeErrorNoAutorizado, mensajeErrorPersonalizado,
    mensajeErrorSesion
} from "../helpers/mensajesSwalError";
import {useAuth} from "../AuthContext";
import Carga from "../componentes/cargando/Cargando";
import Swal from "sweetalert2";
import {mensajeExitoCargando, mesanjeExitoPersonalizado} from "../helpers/mensajesSwalExito";
import {useNavigate} from "react-router-dom";
import BodegaModalEditar from "./bodegaModalEditar";

const ListaBodegas = () => {
    const { verificacionToken, removerLocalStorage } = useAuth();
    const navigate = useNavigate();
    const [bodegas, setBodegas] = useState([]);
    const [ cargando , setCargando] = useState(true);
    const [ bodega, setBodega ] = useState({
        id: 1,
        nombre: "",
        direccion: "",
        puntoVenta: false
    });

    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [nuevaBodega, setNuevaBodega] = useState({
        nombre: "",
        direccion: "",
        puntoVenta: false
    });

    const [modalEditOpen, setModalEditOpen] = useState(false);

    const abrirModalAdd = () => setModalAddOpen(true);
    const cerrarModalAdd = () => {
        setModalAddOpen(false);
        setNuevaBodega({ nombre: "", direccion: "", puntoVenta: false });
    };

    const abrirModalEdit = (b) => {
        setBodega(b)
        setModalEditOpen(true);
    }
    const cerrarModalEdit = () => {
        setModalEditOpen(false);
        setBodega({
            id: 1,
            nombre: "",
            direccion: "",
            puntoVenta: false
        })
    };

    const editarBodega = () => {
        Swal.fire({
            title: "Estas seguro?",
            text: "Editar Bodega!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Generar!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                mensajeExitoCargando();
                await editarBodegaBD();
            }
        });
    }

    const editarBodegaBD = async () => {
        const respuesta = await editarBodegasService(bodega.id, bodega);
        if (respuesta[0]) {
            setBodegas(bodegas =>
                bodegas.map(s =>
                    s.id === respuesta[1].id
                        ? { ...s, nombre: respuesta[1].nombre, direccion: respuesta[1].direccion, puntoVenta: respuesta[1].puntoVenta }
                        : s
                )
            );
            setBodega({
                id: 1,
                nombre: "",
                direccion: "",
                puntoVenta: false
            })
            mesanjeExitoPersonalizado('Se editó con éxito la bodega');
            cerrarModalEdit();
        } else {
            if (respuesta[1] === 404) {
                mensajeErrorPersonalizado(respuesta[2]);
            } else if (respuesta[1] === 401) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/no-autorizado");
            } else {
                mensajeErrorPersonalizado('No se editó la bodega!!');
                cerrarModalEdit();
            }
        }
    }

    const guardarNuevaBodega = () => {
        Swal.fire({
            title: "Estas seguro?",
            text: "Generar Bodega!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Generar!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                mensajeExitoCargando();
                await agregarNuevaBodega();
            }
        });

    };

    const agregarNuevaBodega = async () => {
        const respuesta = await guardarBodegasService(nuevaBodega)

        if (respuesta[0]) {
            setBodegas([
                ...bodegas,
                {
                    id: respuesta[1].id,
                    ...nuevaBodega,
                    productos: []
                }
            ]);
            mesanjeExitoPersonalizado('Se ha agrego con exito la bodega');
            cerrarModalAdd();
        } else {
            if (respuesta[1] === 404) {
                mensajeErrorPersonalizado(respuesta[2]);
            } else if (respuesta[1] === 401) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/no-autorizado");
            } else {
                mensajeErrorPersonalizado('No se agrego la bodega!!');
                cerrarModalAdd();
            }
        }
    }

    const buscarBodega = async () => {
        const respuesta = await  buscarBodegasService()
        if (!respuesta[0]) {
            if (respuesta[3] === 401) {
                removerLocalStorage();
                mensajeErrorSesion();
            } else if (respuesta[3] === 403) {
                removerLocalStorage();
                mensajeErrorNoAutorizado();
            } else {
                removerLocalStorage();
                mensajeError();
            }
        } else {
            setBodegas(respuesta[1]);
            setCargando(false)
        }
    }

    useEffect(() => {
        const init = async () => {
            verificacionToken("ROLE_DUENO");
            buscarBodega();
        };

        init();
    }, []);

    if (cargando) {
        return <Carga />;
    }

    return (
        <div className="bodegas-container">
            <button className="btn-agregar" onClick={abrirModalAdd}>
                + Agregar Bodega
            </button>
            <div className="card-container">
                {bodegas.map(b => (
                    <div key={b.id} className="bodega-card">
                        <h3>{b.nombre}</h3>
                        <p>Dirección: {b.direccion}</p>
                        <p>Punto de venta: {b.puntoVenta ? "Sí" : "No"}</p>
                        <button className="edit-btn m-1" title="Editar" onClick={() => abrirModalEdit(b)}>✏️</button>
                        <button className="edit-btn m-1" title="Detalles">🔍</button>
                    </div>
                ))}
            </div>
            <BodegaModalAgregar
                show={modalAddOpen}
                onHide={cerrarModalAdd}
                data={nuevaBodega}
                setData={setNuevaBodega}
                onSave={guardarNuevaBodega}
            />

            <BodegaModalEditar
                show={modalEditOpen}
                onHide={cerrarModalEdit}
                data={bodega}
                setData={setBodega}
                onSave={editarBodega}
            />
        </div>
    );
};

export default ListaBodegas;

